import { render, staticRenderFns } from "./deploytec.vue?vue&type=template&id=13d07fac"
import script from "./deploytec.vue?vue&type=script&lang=js"
export * from "./deploytec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports